import { Mascotas } from "../../components";

export const CategoriaMascotas = () => <Mascotas />;
